const JSV = require('civicsUtils/JSV');

define(function(require) {
  var log = function(severity, message){
    var LoggerModel = Backbone.Model.extend({
        urlRoot: '/delegate/civics-api/api/portal/logs'
    });
    var logger = new LoggerModel();
    var loggerDetails = {
        severity: severity,
        message: message
    };
    logger.save(loggerDetails, {
        success: function (user) {
            if (__DEV__)console.log(Handlebars.escapeExpression(severity + ": " + message));
        },
        error: function(model, response) {
            console.log(Handlebars.escapeExpression( severity + ": " + message) );
        },
    });
  };

  var getSeverityInNum = function(severity){
    var num = 0;
    if ( severity ){
      switch (severity.toUpperCase()) {
        case 'SUCCESS':
          num=1;
          break;
          case 'INFO':
            num=2;
            break;
            case 'WARNING':
              num=4;
              break;
              case 'USERWARNING':
                num=8;
                break;
                case 'ERROR':
                  num=16;
                  break;
                  case 'FAULT':
                    num=32;
                    break;
                    case 'USERERROR':
                      num=64;
                      break;
                      case 'DEBUG':
                        num=128;
                        break;
        default:
          if( __DEV__)console.log('Cannot determine severity level: ' + severity + '.');
      }
    }
    return num;
  };

  var shouldLog = function(severity){
    var doIt = false;
    var cookieMatches = document.cookie.match('(^|;)\\s*' + "LOG_LEVEL" + '\\s*=\\s*([^;]+)');
    var logLevel = cookieMatches ? cookieMatches.pop() : '';
    var numLogLevel = getSeverityInNum(logLevel);
    var numSeverity = getSeverityInNum(severity);
    if ( numLogLevel != 0 && numSeverity >= numLogLevel) doIt = true;

    return doIt;
  };


  return {
    logSuccess: function(message) {
      if (shouldLog("Success")) log("Success", message)
    },
    logInfo: function(message) {
      if (shouldLog("Info")) log("Info", message)
    },
    logWarning: function(message) {
      if (shouldLog("Warning")) log("Warning", message)
    },
    logUserWarning: function(message) {
      if (shouldLog("UserWarning")) log("UserWarning", message)
    },
    logUserError: function(message) {
      if (shouldLog("UserError")) log("UserError", message)
    },
    logError: function(message) {
      if (shouldLog("Error")) log("Error", message)
    },
    logFault: function(message) {
      if (shouldLog("Fault")) log("Fault", message)
    },
    logDebug: function(message) {
      if (shouldLog("Debug")) log("Debug", message)
    },
  };
});
